import React from 'react';

export const HeaderCell = ({
  width,
  align = 'center',
  first,
  grow,
  sticky,
  active,
  onClick,
  columnKey,
  className = '',
  children,
}) => {
  const cls = [
    'h-full flex items-center',
    grow ? 'flex-1' : 'shrink-0',
    'text-[12px] leading-[16px] tracking-[0.4px] font-normal text-ink-muted',
    align === 'left' ? 'justify-start' : align === 'right' ? 'justify-end' : 'justify-center',
    'px-2',
    !first && sticky !== 'left' ? 'border-l border-line/60' : '',
    sticky === 'left' ? 'sticky left-0 bg-surface border-r border-line/60 z-20' : '',
    sticky === 'right' ? 'sticky right-0 bg-surface z-20' : '',
    active ? 'bg-brand-50 text-brand-600' : '',
    onClick ? 'cursor-pointer select-none hover:text-ink' : '',
    className,
  ].join(' ');
  return (
    <div
      className={cls}
      style={grow ? { minWidth: width } : { width }}
      onClick={onClick}
      data-column-header={columnKey || undefined}
    >
      <span className="whitespace-nowrap">{children}</span>
    </div>
  );
};

export const BodyCell = ({
  width,
  align = 'center',
  first,
  grow,
  sticky,
  bg = 'bg-card',
  active,
  className = '',
  children,
}) => {
  const cls = [
    'h-full flex items-center min-w-0',
    grow ? 'flex-1' : 'shrink-0',
    align === 'left' ? 'justify-start' : align === 'right' ? 'justify-end' : 'justify-center',
    'px-2',
    !first && sticky !== 'left' ? 'border-l border-line/60' : '',
    sticky === 'left' ? `sticky left-0 ${bg} border-r border-line/60 z-[1]` : '',
    sticky === 'right' ? `sticky right-0 ${bg} z-[1]` : '',
    active ? 'bg-brand-50' : '',
    'text-[12px] text-ink',
    className,
  ].join(' ');
  return (
    <div className={cls} style={grow ? { minWidth: width } : { width }}>
      {children}
    </div>
  );
};
